import { SHOW_DIALOG, SHOW_MODAL } from '../constants/ActionTypes';

export const showDialog = (data: {
	appAlert?: boolean;
	title?: string;
	msg?: string;
	leftBtn?: string;
	rightBtn?: string;
	handleEditState?: () => void;
	leftAction?: () => void;
	rightAction?: () => void;
}) => ({
	type: SHOW_DIALOG,
	payload: { ...data },
});

export const editModal = (data: {
	type: string;
	title: string;
	name: string;
	handleEditState?: () => void;
}) => ({
	type: SHOW_MODAL,
	payload: { ...data },
});
